import React, { Component } from 'react';


class ShippingDeliveryComponent extends Component{
  
    render() 
    { 
      
        return ( 
           < React.Fragment> 
            <div style={{ fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", padding: '1em' }}>
            <h2>Shipping and Delivery Policy</h2>
<p>All our services are delivered electronically. There is no physical product to ship, and delivery is typically instant or within a few minutes after successful payment.</p>
<p>If you experience any delay or issues, please contact us at <a href="mailto:support@linuxmantra.com">support@linuxmantra.com</a>.</p>
    </div>

            


            
           </React.Fragment>
        )

}
}

export default ShippingDeliveryComponent;